export default {
  // ADD BANK ACCOUNT
  "add-bank-account_page-title": "Enter banking information",
  "___add-bank-account_action_submit": "",
  "add-bank-account_text_loading-message": "Saving Bank Account…",
  "add-bank-account_text_success-message": "Your bank account information has been saved.",
  "___add-bank-account_text_error-message_default": "",
  "add-bank-account_text_error-message_status-105": "This bank account cannot be saved. Please contact Customer Service for more information at 1-800-859-2144.",
  "add-bank-account_text_refresh-data-error-message": "Your bank account has been added but we were unable to refresh the data on the screen. Please refresh the page.",
  "___add-bank-account_label_checking": "",
  "___add-bank-account_label_savings": "",
  "___add-bank-account_action_done": "",
  "___add-bank-account_action_refresh": "",
  "___add-bank-account_title_confirm-close": "",
  "___add-bank-account_text_confirm-close": "",
  "___add-bank-account_action_confirm-close_cancel": "",
  "___add-bank-account_action_confirm-close_confirm": "",
  "___add-bank-account_form-label_account-number": "",
  "___add-bank-account_form-label_confirm-account-number": "",
  "___add-bank-account_form-label_routing-number": "",
  "___add-bank-account_form-label_account-type": "",
  "___add-bank-account_form-label_bank-name": "",
  "add-bank-account_form-label_terms-and-conditions": "I authorize SelectAccount to withdraw from this bank account as directed by me in order to fund my Health Savings Account. I confirm this information is accurate and SelectAccount is not responsible for transactions made based on incorrect banking information.",
  "add-bank-account_form-error_account-number_required": "Enter the account number",
  "add-bank-account_form-error_account-number_invalid-format": "Invalid Account Number",
  "add-bank-account_form-error_account-number_length": "Account number cannot be longer than %maxLength% characters.",
  "add-bank-account_form-error_confirm-account-number_required": "Re-enter the account number",
  "add-bank-account_form-error_confirm-account-number_same-as": "Please validate the Account Number",
  "add-bank-account_form-error_routing-number_required": "Enter the routing number",
  "add-bank-account_form-error_routing-number_invalid-format": "Invalid Routing Number",
  "add-bank-account_form-error_routing-number_invalid": "The Routing number entered is invalid",
  "add-bank-account_form-error_routing-number_length": "Invalid Routing Number",
  "add-bank-account_form-error_account-type_required": "Select the account type",
  "add-bank-account_form-error_bank-name_required": "Please enter a valid routing number",
  "___add-bank-account_form-error_terms-and-conditions_required": "",

  // MAKE PRIMARY BANK ACCOUNT
  "make-primary-bank-account_page-title": "Do you want to make this your Primary Account?",
  "make-primary-bank-account_page-description": "Automatic reimbursements will go to this account. Deposits to the previous primary account will stop.",
  "___make-primary-bank-account_text_loading-message": "",
  "make-primary-bank-account_text_success-message": "Your bank account was updated successfully. A notification email has been sent to your account.",
  "___make-primary-bank-account_action_done": "",
  "___make-primary-bank-account_action_cancel": "",
  "___make-primary-bank-account_action_confirm": "",
  "___make-primary-bank-account_label_checking": "",
  "___make-primary-bank-account_label_savings": "",
  "___make-primary-bank-account_title_confirm-close": "",
  "___make-primary-bank-account_text_confirm-close": "",
  "___make-primary-bank-account_action_confirm-close_cancel": "",
  "___make-primary-bank-account_action_confirm-close_confirm": "",
  "make-primary-bank-account_text_refresh-data-error-message": "Your bank account has been updated but we were unable to refresh the data on the screen. Please refresh the page.",

  // REMOVE BANK ACCOUNT
  "remove-bank-account_page-title": "Are you sure you'd like to delete this bank account?",
  "remove-bank-account_page-description": "Canceling this account will make it immediately unavailable for transactions except those in progress.",
  "remove-bank-account_text_loading-message": "Removing Bank Account…",
  "remove-bank-account_text_success-message": "The bank account was removed successfully. A notification email has been sent to your account.",
  "___remove-bank-account_action_done": "",
  "___remove-bank-account_action_cancel": "",
  "remove-bank-account_action_confirm": "Delete Account",
  "___remove-bank-account_label_checking": "",
  "___remove-bank-account_label_savings": "",
  "___remove-bank-account_title_confirm-close": "",
  "___remove-bank-account_text_confirm-close": "",
  "___remove-bank-account_action_confirm-close_cancel": "",
  "___remove-bank-account_action_confirm-close_confirm": "",
  "remove-bank-account_text_refresh-data-error-message": "Your bank account has been deleted but we were unable to refresh the data on the screen. Please refresh the page.",
};